import Link from 'next/link';
import { ArrowIcon } from '@netfront/ui-library';
import PercentagePill from '../PercentagePill/PercentagePill';
import { useRouter } from 'next/router';
import { cn } from '@/utils';

export function Quicklink({
  icon,
  link,
  surTitle,
  title,
  percentage,
}: {
  surTitle?: string;
  title: string;
  percentage?: number;
  link: string;
  icon?: React.ReactNode;
}) {
  const router = useRouter();

  return (
    <li className="m-0 w-full c-quicklink">
      <Link href={link} className="text-decoration-none w-full ">
        <button
          className={cn('flex gap-2 px-3 py-2 items-center rounded w-full c-button shadow c-quicklink', {
            'bg-primary text-primary-foreground': router.asPath === link,
            'bg-surface text-surface-foreground hover:bg-primary hover:text-primary-foreground': router.asPath !== link,
          })}
        >
          {icon && <span>{icon}</span>}
          <span className="flex-1 flex flex-col text-left">
            {surTitle && <p className="text-sm weight-600">{surTitle}</p>}
            <h4 className="weight-500 text-sm flex-1">{title}</h4>
          </span>
          <span className="flex flex-col items-end">
            {percentage != null && (
              <PercentagePill percentage={percentage} className="flex-1 shadow-none bg-secondary c-quicklink__percentage " />
            )}
            <ArrowIcon className="w-5 h-5 rotate-[-90] border rounded-full p-1 border-primary text-primary flex-1 aspect-ratio-square c-quicklink__arrow" />
          </span>
        </button>
      </Link>
    </li>
  );
}
